import { Injectable } from '@angular/core';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';
import { LocalQuota } from '@asm/features/sync/models/pricing-tables.model';

@Injectable({ providedIn: 'root' })
export class QuotaRepository extends RepositoryBase<LocalQuota> {
  protected readonly KEY_PATH = 'quotas';
}
